const choices = {
    loan: 'intégrée au financement',
    client: 'apportée par le client',
    promoter: 'avancée par le promoteur',
};

export default choices;
